import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapRoutingModule } from './map-routing.module';
import { MapComponent } from './map/map.component';
import { HttpClientModule } from '@angular/common/http';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { DeviceListModalModule } from '../../components/map/device-list-modal/device-list-modal.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [MapComponent],
  imports: [CommonModule, FiltersModule, HttpClientModule, MapRoutingModule, DeviceListModalModule, MaterialModule],
})
export class MapModule {}
